import { markFunction } from 'owa-performance';
import markerKeys from './plt/markerKeys';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { getQueryStringParameters } from 'owa-querystring';
import { UserBootStrings } from 'owa-config';

const CULTURE_QUERYSTRING_PARAMETER_NAME = 'culture';

function getCultureOverride(location: Location) {
    let queryOptions = getQueryStringParameters(location);
    let devDefault = process.env.NODE_ENV === 'dev' ? 'qps-ploc' : null;
    return queryOptions[CULTURE_QUERYSTRING_PARAMETER_NAME] || devDefault;
}

export default markFunction(async function initializeLocales(
    userBootStrings: UserBootStrings,
    initializeLocalization: (culture: string, bootStrings: Record<string, string>) => Promise<void>
) {
    let culture = getCultureOverride(getHostLocation()) || userBootStrings.language;

    await initializeLocalization(culture, userBootStrings.bootStrings);
    return;
},
markerKeys.localeInitialization);
